import { h, render } from 'preact';
import { BrowserRouter } from 'react-router-dom';
import App from './App';
import 'preact/devtools';
import 'bootstrap/dist/css/bootstrap.css';
import '../../css/variables.css';
import '../../css/layout.css';
import '../../css/styles.css';
const container = document.getElementById('app');
const renderApp = () => {
    render(h(BrowserRouter, null,
        h(App, null)), container, container.lastChild);
};
renderApp();
if (module.hot) {
    module.hot.accept('./App', () => {
        renderApp();
    });
}
